/**
* Detail experience selector
*
* This function create an selector
*
*/

export const results = (state) => state.detailExperienceReducer;
export const resData = (state) => state.detailExperienceReducer.data.data;
